import request from '@/utils/request'
// import {HttpMethod} from "../../../IELTS_ADMIN/src/utils/auth";



export function getUserProjectAssociationList (tab_name) {
  return request({
    url: '/api/v4/study_abroad/project/get_user_project_association_list',
    method: 'get',
    params: { 'tab_name': tab_name }
  })
}
export function getProjectAssociationList (tab_name) {
  return request({
    url: '/api/v4/study_abroad/project/get_project_association_list',
    method: 'get',
    params: { 'tab_name': tab_name }
  })
}
export function delProjectAssociation (data) {
  return request({
    url: '/api/v4/study_abroad/project/del_project_association',
    method: 'post',
    data: data
  })
}

export function addProjectAssociation (data) {
  return request({
    url: '/api/v4/study_abroad/project/add_project_association',
    method: 'post',
    data: data
  })
}

export function getQuestionnaire (data) {
  return request({
    url: '/api/v4/student/get_questionnaire',
    method: 'post',
    data: data
  })
}



export function getProjectPlanningList(data) {
  return request({
    url: '/api/v4/study_abroad/project/get_project_planning_list',
    method: 'POST',
    data: data
  })
}

export function get_project_planning_year(data) {
  return request({
    url: '/api/v4/study_abroad/project/get_project_planning_year',
    method: 'POST',
    data: data
  })
}

export function get_user_base_statistics(data){
  return request({
    url: '/api/v4/study_abroad/project/get_user_base_statistics',
    method: 'post',
    data: data
  })
}

export function log_lists(data) { //日志列表
  return request({
    url: '/api/v4/study_abroad/project/get_log_list',
    method: 'post',
    data: data
  })
}


export function add_project_planning(data) { // 添加项目规划
  return request({
    url: '/api/v4/study_abroad/project/add_project_planning',
    method: 'post',
    data: data
  })
}

export function del_project_planning(data) { // 删除项目规划
  return request({
    url: '/api/v4/study_abroad/project/del_project_planning',
    method: 'post',
    data: data
  })
}

export function add_document(data) {
  return request({
    url: '/api/v4/student/user_information_add_document',
    method: 'POST',
    data: data
  })
}

export function get_study_abroad_information_statistics(data){
  return request({
    url: '/api/v4/student/get_study_abroad_information_statistics',
    method: 'get',
    params: data
  })
}

// 更新Rl机构是否自己填写字段状态
export function update_institution_write(id,status,rl_id) {
  const param = {}
  param['id'] = id
  param['status'] = status
  param['rl_id'] = rl_id
  return request({
    url: '/api/v4/student/update_institution_write',
    method: 'post',
    data: param
  })
}

export function profile_update_three(data) {
  return request({
    url: '/api/v4/student/editUserBase',
    method: 'POST',
    data: data
  })
}


export function check_sing_document(data){
  return request({
    url: '/api/v4/student/check_sing_document',
    method: 'get',
    params: data
  })
}

export function check_is_addsing_document(data){
  return request({
    url: '/api/v4/student/check_is_addsing_document',
    method: 'get',
    params: data
  })
}



export function user_information_info_add(data) {
  return request({
    url: '/api/v4/student/user_information_info_add',
    method: 'post',
    data: data
  })
}
export function user_information_document_edit(data) {
  return request({
    url: '/api/v4/student/user_information_document_edit',
    method: 'post',
    data: data
  })
}

export function profile_update_two(data) { //保存学生rl 三维数据
  return request({
    url: '/api/v4/student/Profile/update',
    method: 'post',
    data: data
  })
}


export function student_profile(data) { //获取学生rl 三维数据
  return request({
    url: '/api/v4/student/getProfile',
    method: 'post',
    data: data
  })
}

export function document_list(data) {
  return request({
    url: '/api/v4/student/user_information_document_list',
    method: 'get',
    params: data
  })
}

export function del_document(data) {
  return request({
    url: '/api/v4/student/user_information_del_document',
    method: 'get',
    params: data
  })
}



export function profile_list(data) { // 学生详情
  return request({
    url: '/api/v4/student/getProfile/list',
    method: 'post',
    data: data
  })
}
export function profile_update(data) { // 学生详情修改
  return request({
    url: '/api/v4/student/getProfile/update',
    method: 'post',
    data: data
  })
}


export function email_code(data) { // 学生163邮箱验证
  return request({
    url: '/api/v4/student/mail_code',
    method: 'post',
    data: data
  })
}

export function email_bind(data) { // 学生163邮箱验证
  return request({
    url: '/api/v4/student/mail_bind',
    method: 'post',
    data: data
  })
}
export function email_empower_bind(data) { // 学生163邮箱验证
  return request({
    url: '/api/v4/student/mail_empower_bind',
    method: 'post',
    data: data
  })
}

export function user_bind_info(data) { // 删除选校
  return request({
    url: '/api/v4/classroom/student/getProfile/crm/info',
    method: 'POST',
    data: data
  })
}

export function lessonOpenInfo(data) {
  return request({
    url: '/api/v4/classroom/student/getProfile/study_abroad_lesson_open_info',
    method: 'post',
    data: data
  })
}




export function get_email_annex_list(data) { // 获取邮箱模板内容
  return request({
    url: '/api/v4/classroom/study/abroad/get_email_annex_list',
    method: 'post',
    data: data
  })
}

export function save_email_template(data) { // 保存邮箱模板
  return request({
    url: '/api/v4/classroom/study/abroad/save_email_template',
    method: 'post',
    data: data
  })
}




export function edit_user_company_magnets(data) {
  return request({
    url: '/api/v4/classroom/study/abroad/company_magnets_edit',
    method: 'post',
    data: data
  })
}

export function del_user_company_magnets(data) {
  return request({
    url: '/api/v4/classroom/study/abroad/company_magnets_del',
    method: 'post',
    data: data
  })
}

export function get_user_company_magnets(data) {
  return request({
    url: '/api/v4/classroom/study/abroad/company_magnets_get',
    method: 'post',
    data: data
  })
}



export function edit_user_doctor_magnets(data) {
  return request({
    url: '/api/v4/classroom/study/abroad/doctor_magnets_edit',
    method: 'post',
    data: data
  })
}

export function del_user_doctor_magnets(data) {
  return request({
    url: '/api/v4/classroom/study/abroad/doctor_magnets_del',
    method: 'post',
    data: data
  })
}

export function get_user_doctor_magnets(data) {
  return request({
    url: '/api/v4/classroom/study/abroad/doctor_magnets_get',
    method: 'post',
    data: data
  })
}


export function add_user_school_choice(data) {
  return request({
    url: '/api/v4/classroom/study/abroad/school/choice/add',
    method: 'post',
    data: data
  })
}
export function del_user_school_choice(data) {
  return request({
    url: '/api/v4/classroom/study/abroad/school/choice/del',
    method: 'get',
    params: data
  })
}
export function school_list(data) {
  return request({
    url: '/api/v4/classroom/study/abroad/school/lists',
    method: 'get',
    params: data
  })
}
export function update_user_school_choice(data) {
  return request({
    url: '/api/v4/classroom/study/abroad/school/choice/update_status',
    method: 'post',
    data: data
  })
}

/**
 * 检测是否有留学正单服务
 * @returns
 */
export function checkHaveAbroadService() {
  return request({
    url:'/api/v2/web/check_study_abroad_lesson',
    method:'get'
  })
}

/**
 * 检测是否绑定邮箱
 * @returns
 */
export function checkUserEmail() {
  return request({
    url:'/api/v2/web/check_user_email',
    method:'get'
  })
}

/**
 * 添加选校申请结果
 * @param {*} user_school_choice_id 选校id
 * @param {*} apply_result 申请结果
 * @param {*} scholarship 奖学金
 * @param {*} result_remarks 申请结果备注
 * @param {*} result_apply_annex 申请结果凭证(文件附件)
 * @returns
 */
export function addSchoolApplyResultApi(user_school_choice_id,apply_result,scholarship,result_remarks,result_apply_annex) {
  return request({
    url:'/api/v4/classroom/study/abroad/school/choice/add_apply_result',
    method:'post',
    data:{
      user_school_choice_id:user_school_choice_id,
      apply_result:apply_result,
      scholarship:scholarship,
      result_remarks:result_remarks,
      result_apply_annex:result_apply_annex,
    }
  })
}

/**
 * 放弃选校
 * @param {选校id} id
 * @returns
 */
export function giveupSchoolChoiceApi(id) {
  return request({
    url:"/api/v4/classroom/study/abroad/school/choice/give_up",
    method:'post',
    data:{
      id:id
    }
  })
}


export function setTaociRolling(data) {
  return request({
    url: '/api/v4/classroom/study/abroad/setTaociRolling',
    method: 'post',
    data: data
  })
}


export function getUserInfoApi(data) {
  return request({
    url: '/api/v4/st/userinfo/detail',
    method: 'get',
    params: data
  })
}

export function updateUserInfoApi(data) {
  return request({
    url: '/api/v4/st/userinfo/update',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/mycenter_studyabroad.js